export default "__VITE_ASSET__DEWQ4VKg__"